import { memo, useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import Image from 'next/image'
import styles from './for-artists.module.scss'

type Props = {
  className: string
  bgSrc: string
  children: React.ReactNode
}

const SectionContainer = ({ className, children, bgSrc }: Props) => {
  const target = useRef<HTMLDListElement>()
  const { scrollYProgress } = useScroll({ target, offset: [ 'start end', 'end start' ]})
  const translateY = useTransform(scrollYProgress, [ 0, 1 ], [ 0, -400 ])
  const opacity = useTransform(scrollYProgress, [ 0, 0.5, 1 ], [ 0, 1, 0 ])
  return (
    <>
      <div className={styles.bgImgContainer}>
        <motion.div
          className={styles.parallax}
          style={{ translateY, opacity }}
        >
          <Image
            src={bgSrc}
            alt=""
            width={500}
            height={500}
            sizes="120%"
          />
        </motion.div>
      </div>
      <section ref={target} className={className}>
        {children}
      </section>
    </>
  )
}

export default memo(SectionContainer)
